import { Link } from "@tanstack/react-router";

export const SUPPORT_EMAIL = "support@babia.app";

export function LegalLinks() {
  return (
    <nav aria-label="Legal and support" className="flex flex-wrap gap-x-5 text-[14px]">
      <Link
        to="/privacy"
        className="inline-flex min-h-11 items-center underline underline-offset-4"
      >
        Privacy Policy
      </Link>
      <Link to="/terms" className="inline-flex min-h-11 items-center underline underline-offset-4">
        Terms of Service
      </Link>
      <Link
        to="/support"
        className="inline-flex min-h-11 items-center underline underline-offset-4"
      >
        Support
      </Link>
      <a
        href={`mailto:${SUPPORT_EMAIL}`}
        className="inline-flex min-h-11 items-center underline underline-offset-4"
      >
        Contact
      </a>
    </nav>
  );
}
